<template>
  <div class="row justify-between items-center">
    <label :for="inputId">
      <r-icon name="add_a_photo" class="text-riseup-blue cursor-pointer" size="20px"/>
    </label>
    <span v-if="showSuccessMessage" class="text-riseup-green r-text-bold r-text-body-small">הועלתה בהצלחה!</span>
    <div @click="removeFile">
      <trash-icon />
    </div>
  </div>
</template>

<script>
import RIcon from '@/components/base/RIcon';
import TrashIcon from '@/components/styled/TrashIcon';

export default {
  name: 'FileUploadControls',
  components: { TrashIcon, RIcon },
  props: {
    inputId: {
      type: String,
      required: true,
    },
    showSuccessMessage: Boolean,
  },
  methods: {
    removeFile() {
      this.$emit('removeFile');
    },
  },
};
</script>
